import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const EmailOpened = forwardRef<SVGSVGElement, SvgIconProps>(
  function EmailOpened(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path
          d="M9 .16L1.644 4.19C1.07 4.506 0 5.12 0 6.398v9.287c0 .75.724 1.357 1.625 1.357h14.75c.9 0 1.625-.607 1.625-1.357V6.397c0-1.256-1.053-1.883-1.644-2.206L9 .159zm0 1.862l7.169 3.931L9 11.028 1.831 5.953 9 2.022z"
          transform="scale(0.9, 0.9) translate(3, 3)"
        />
      </SvgIcon>
    )
  },
)

export default EmailOpened
